import * as React from 'react';
import BalanceSheetCoreWrapper from '../AfrCore/BalanceSheetCoreWrapper';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';




const BalanceSheetA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <BalanceSheetCoreWrapper userRole={isAdminUser ? "ADMIN" : "USER"} />
        </React.Fragment>
    );
}

export default BalanceSheetA;